import { compactMap, filterFilms, FilterType, getDistinctItems, getFilmById, getFilms, getFilterByIdAndType } from '@vista/omnichannel-components-domain';
export const getFilmIdsToDisplay = (props) => {
    const { filmIds, showAllFilms, filterId, showtimes, isLoading } = props;
    if (!isLoading) {
        if (showAllFilms)
            return getAllFilmIds(filterId);
        if (filmIds)
            return filterFilmIds(filmIds, filterId);
    }
    // Note: showtimes are already filtered
    return getFilmIdsForShowtimes(showtimes);
};
const getAllFilmIds = (filterId) => {
    var _a, _b;
    const filmFilter = getFilmFilterFromShowtimeFilterId(filterId);
    return (_b = (_a = getFilms(undefined, filmFilter)) === null || _a === void 0 ? void 0 : _a.map(film => film.id)) !== null && _b !== void 0 ? _b : [];
};
const filterFilmIds = (filmIds, filterId) => {
    const filmFilter = getFilmFilterFromShowtimeFilterId(filterId);
    if (!filmFilter)
        return getDistinctItems(filmIds);
    const films = compactMap(filmIds, getFilmById);
    const filteredFilmIds = filterFilms(filmFilter, films).map(film => film.id);
    return getDistinctItems(filteredFilmIds);
};
/**
 * Returns the unique list of film IDs for a given list of showtimes.
 */
const getFilmIdsForShowtimes = (showtimes) => {
    return getDistinctItems(showtimes.map(s => s.filmId));
};
const getFilmFilterFromShowtimeFilterId = (filterId) => {
    const filter = filterId ? getFilterByIdAndType(filterId, FilterType.Showtime) : undefined;
    if (!filter)
        return;
    const filmFilter = Object.assign(Object.assign({}, filter), { type: FilterType.Film, baseData: [], sections: Object.assign(Object.assign({}, filter.sections), { category: {
                fixed: [],
                options: []
            } }) });
    return filmFilter;
};
